import { render, staticRenderFns } from "./PositionCardMenu.vue?vue&type=template&id=5dc6e8e6"
import script from "./PositionCardMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionCardMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports